import { FeatureCard } from "../components/FeatureCard";
import type { LandingContent } from "../content/types";

type FeatureSectionProps = {
  features: LandingContent["features"];
};

export function FeatureSection({ features }: FeatureSectionProps) {
  return (
    <section className="feature-section" aria-label="Moodshot features">
      <div className="page-container feature-grid">
        {features.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>
    </section>
  );
}
